module.exports = __webpack_public_path__ + "static/media/merchflow_logo_transparent.5765da1a.png";